/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateful
 */
import React, { PropTypes } from 'react';
import ReactPhoneInput from 'components/Form/Fields/PhoneNumber'
import sendPhoneVerification from 'controllers/user/sendPhoneVerification'
import registerUser from 'controllers/user/registerUser'
import MobileDetect from 'mobile-detect'
import loginAsUser from 'controllers/user/loginAsUser';
import {alert} from 'util/alert'
import locale from './locale'
import './Modal.scss';

const COUNT_DOWN_SECONDS = 59
const DEFAULT_REGION_CODE = 'ca';

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      steps: 1,
      phone: {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE },
      newPhone: '',
      verificationCode: '',
      agentId: '',
      password: '',
      email: '',
      errorMsg: '',
      showMsg: false,
      showVerificationFailure: false,
      counterTime: COUNT_DOWN_SECONDS,
      resendCode: false
    }

    this.createSchool = this.createSchool.bind(this);
    this.startUsing = this.startUsing.bind(this);
    this.onChange = this.onChange.bind(this)
    this.onKeyDownRegisterPhone = this.onKeyDownRegisterPhone.bind(this)
  }

  createSchool() {
    const {
      proceed,
    } = this.props;

    const {
      phone = '',
      password,
      newPhone
    } = this.state;

    this.setState({
      creatingSchool: true,
    });

    loginAsUser({
      username: newPhone,
      password,
    }).then((res)=>{
      if (res.data && res.data.result === 'success') {
        localStorage.setItem('token', res.data.user_token);
        proceed({
          createSchool: true,
        });
      }
    }).catch((err)=>{
      console.error(err);
    });
  }

  startUsing(){
    const {phone = '', password} = this.state;

    let newPhone = phone.country_code + phone.national_number

    loginAsUser({username: newPhone, password})
    .then((res) => {
      if (res.data && res.data.result === 'success') {
        localStorage.setItem('token', res.data.user_token);
        this.props.proceed({
          createSchool: false,
        });
      }
    })
    .catch((err) => {console.log(err)})
  }

  onChange(name) {
    if(name == 'phone'){
      return (e) => {
        this.setState({[name]: e});
      }
    } else {
      return (e) => {
        this.setState({[name]: e.target.value});
      }
    }
  }

  onKeyDownRegisterPhone(event) {
    const {phone} = this.state
    if (event.keyCode == 13) {
      sendPhoneVerification({phone, check_phone: 'sendIfUserNotExist'})
      .then((res) => {
        if(res.result == 'success'){
          this.setState({steps: 2, showMsg: false, showVerificationFailure: true}, onHeightChange(600, this.modelContentRef))
        } else {
          this.setState({showMsg: true, showVerificationFailure: false})
        }
      })
      .catch((err) => {
        this.setState({showVerificationFailure: true})
      })
    }
  }

  setVerificationCounter() {
    this.setState({ resendCode: true })
    this.timmer = setInterval(() => {
      if (this.state.counterTime > 0) {
        this.setState({ counterTime: (this.state.counterTime - 1) });
      } else {
        this.setState({ resendCode: false, counterTime: COUNT_DOWN_SECONDS });
        this.clearCounter();
      }
    }, 1000);
  }

  clearCounter() {
    clearInterval(this.timmer);
  }
  
  renderSignUpProcess(){
    let {steps, phone, verificationCode, agentId, password, errorMsg, showMsg, creatingSchool, email, showVerificationFailure, counterTime , resendCode, newPhone} = this.state
    let {dismiss, onHeightChange, type} = this.props

    if (steps == 1) {
      return (
        <div className='row text-center RegisterUserModal--step-1'>
          <div>
            <div className='nav-btn'>
              <span className='pull-right register-cancel'><i className="fa icon-cancel pull-left register-cancel" onClick={() => {dismiss()}}></i></span>
            </div>
            <img
              className="register-circle"
              src={require('./images/Ellipse_1.png')}
            />
            <p className='register-msg'>{__('Please enter your phone number', 'appwrapper', null, true)}</p>
            <div className={showMsg ? 'showMsg register-msg3-failed' : 'noMsg'}>{__('User already registered, please sign in or sign up with different phone number', 'appwrapper')}</div>
            <div className={showVerificationFailure ? 'showMsg register-msg3-failed' : 'noMsg'}>{__('Invalid phone number!', 'appwrapper')}</div>
            <div className='register-phone'>
              <ReactPhoneInput defaultCountry={'ca'}
                value={phone}
                onChange={this.onChange('phone')}
                onKeyDown={this.onKeyDownRegisterPhone}
                onlyCountries={['ca', 'us']}
                dropdownStyle={{'text-align': 'left', 'width': '300px'}}
                autoComplete="off"
                disableAreaCodes={true}
              />
              <button className='btn btn-primary register-phone-btn' onClick={() => {
                let newPhone= phone.country_code + phone.national_number
                this.setState({newPhone: newPhone})

                sendPhoneVerification({phone: newPhone, check_phone: 'sendIfUserNotExist'})
                .then((res) => {
                  if(res.result == 'success'){
                    this.setState({steps: 2, showMsg: false, showVerificationFailure: false}, onHeightChange(540, this.modelContentRef));
                    this.setVerificationCounter();
                  } else if (res.result === 'failure' && res.reason === 'wrong phone number') {
                    this.setState({showMsg: false, showVerificationFailure: true})
                  } else {
                    this.setState({showMsg: true, showVerificationFailure: false})
                  }
                })
                .catch((err) => {
                  this.setState({showVerificationFailure: true})
                })
              }}>
                {__('Next ', 'appwrapper', null, true)}
              </button>
            </div>
          </div>
        </div>
      )
    } else if (steps == 2) {
      return (
        <div className='row text-center RegisterUserModal--step-2'>
          <div>
            <div className='nav-btn'>
              <span className='pull-right register-cancel'>
                <i className="fa icon-cancel pull-left register-cancel" onClick={() => {dismiss()}}></i>
              </span>
              <span className='pull-left register-cancel'>
                <i className="fa icon-left-big pull-left register-cancel" onClick={() => {
                  this.clearCounter();
                  this.setState({steps: 1, counterTime: COUNT_DOWN_SECONDS}, onHeightChange(400))}
                }></i>
              </span>
            </div>
            <img className="register-circle" src={require('./images/Ellipse_1.png')} />
            <p className='register-msg'>{__('Verify your phone number', 'appwrapper')}</p>
            <p className='register-msg2'>{__('The verification code is sent to: {phone}', 'appwrapper', {phone: newPhone})}</p>
            {
              !resendCode && 
              <p className='register-msg2'>
                <a className='resendBtn' onClick={() => {
                  let newPhone= phone.country_code + phone.national_number

                  sendPhoneVerification({phone: newPhone, check_phone: 'sendIfUserNotExist'})
                  .then((res) => {
                    this.setVerificationCounter();
                  })
                }}>{__('Resend verification code', 'appwrapper')}</a>
              </p>
            }
            {
              resendCode && 
              <p className='register-msg2'>{__('Verification code can be resent in {counterTime} seconds ', 'appwrapper', {counterTime: counterTime})}</p>
            }
            <p className={errorMsg == 'User already exists' ? 'register-msg3-failed' : 'register-msg3-success'}>{__('User already registered, please sign in or sign up with different phone number', 'appwrapper')}</p>
            <p className={errorMsg == 'new password is less than 6 characters' ? 'register-msg3-failed' : 'register-msg3-success'}>{__('Password must be at least 6 characters', 'appwrapper')}</p>
            <p className={errorMsg == 'pin is wrong' ? 'register-msg3-failed' : 'register-msg3-success'}>{__('Incorrect PIN', 'appwrapper')}</p>
            <p className={errorMsg == 'The verification code has expired' ? 'register-msg3-failed' : 'register-msg3-success'}>{__('PIN expired', 'appwrapper')}</p>

            <div className='container-fluid' style={{width: '60%'}}>
              <input type='number' className='form-control pin-number' placeholder={__('Verification Code', 'appwrapper')} value={verificationCode} onChange={this.onChange('verificationCode')} />
              <input type='password' className='form-control password' placeholder={__('New Password', 'appwrapper')}
              value={password} onChange={this.onChange('password')} onKeyPress={this.onUserSignup1} />
              <input type='email' className='form-control password' placeholder={__('Email', locale)} value={email} onChange={this.onChange('email')} />
              <input type='number' className='form-control agent_id' placeholder={__('Agent ID (Optional)', 'appwrapper')}
              value={agentId} onChange={this.onChange('agentId')} onKeyPress={this.onUserSignup1} />
              <p style={{fontSize: '12px'}}>{__('By clicking Register, you agree to our ', 'appwrapper')}<a target="_blank" href={__('https://base.classtop.com/terms-of-service-en.html', 'appwrapper')}>{__('Terms of Service', 'appwrapper')}</a>.</p>
              <button className='btn btn-primary register2-phone-btn btn-block registerBtn' onClick={() => {
                if(!verificationCode || !password || !email){
                  return alert.warning(__('Verification Code, New Password, and Email are required', locale))
                  .then(() => {})
                }
                let newPhone= phone.country_code + phone.national_number

                registerUser({phone: newPhone, pin: verificationCode, new_password: password, agent_id: agentId, email})
                .then((res) => {
                  if(res.result == 'success'){
                    this.setState({steps: 3}, onHeightChange(600, this.modelContentRef))
                  } else if(res.result == 'failure'){
                    this.setState({errorMsg: res.reason})
                  }
                })
              }}>{__('Register', 'appwrapper')}</button>
            </div>
          </div>
        </div>
      )
    } else if (steps == 3){
      if (type === 'mobile') {
        return (
          <div className='row text-center RegisterUserModal--step-3-mobile'>
            <div className='mobile-success'>
              <img className="register-circle" src={require('./images/Group@2x.png')}/>
              <div className='mobile-success-text'>{__('Sign up successful, please download our app!', 'appwrapper')}</div>
              <button className='btn btn-primary btn-block register-phone' onClick={() => {
                let md = new MobileDetect(window.navigator.userAgent);

                if(md.os() == 'iOS'){
                  window.location.href = 'https://itunes.apple.com/ca/app/classtop-for-school-staff/id1315842973?mt=8'
                } else if (md.os() == 'AndroidOS'){
                  window.location.href = 'https://play.google.com/store/apps/details?id=com.company.classtop.ionic&hl=en'
                } else {
                }
              }}>{__('Download', 'appwrapper')}</button>
            </div>
          </div>
        );
      } else if (type == 'desktop') {
        return (
          <div className='desktopRegisterSuccess RegisterUserModal--step-3-desktop'>
            <div className='bg' style={{ backgroundImage: `url(${successBg})` }}></div>
            <section className='footer'>
              <h1>{__('Register Successful', 'appwrapper')}</h1>
              <h5>{__('Login account: {phone}', 'appwrapper', { phone: newPhone })}</h5>
              { creatingSchool !== true && <a className='btn btn-primary' onClick={this.createSchool}>{__('Create School', 'appwrapper')}</a> }
              { creatingSchool !== true && <a className='btn' onClick={this.startUsing}>{__('Start Using', 'appwrapper')}</a> }
            </section>
          </div>
        )
      }
    } else {
      return (
        <div />
      )
    }
  }

  render() {
    return (
      <div className='registerUser-modal-content' ref={(ref) => {this.modelContentRef = ref}}>
        <div className='container-fluid'>
          {this.renderSignUpProcess()}
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/RegisterUser/ModalContent.js